import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Divider, Icon, Input, message, Modal, Row, Select, Tag } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { BRAND_ENDPOINT, PRODUCT_ENDPOINT, PRODUCT_TYPE_ENDPOINT } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';

const { Option } = Select;
const { confirm } = Modal;

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default () => {

	const [productType, setProductType] = useState([]);
	const [brands, setBrands] = useState([]);
	const [ds, setDs] = useState([]);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});
	const [selectedRow, setSelectedRow] = useState([]);

	const history = useHistory();

	useEffect(() => {
		const init = async () => {
			window.setLoading(true);
			const apiList = [CommonService.get(PRODUCT_TYPE_ENDPOINT, {}), CommonService.get(BRAND_ENDPOINT, {}), CommonService.get(PRODUCT_ENDPOINT, {
				page: page.currentPage - 1,
				size: page.perpage
			})];
			const resp = Promise.all(apiList);
			const [productTypeRes, brandRes, productRes] = await resp;
			setDs(productRes.data?.contents);
			setPage({ ...page, total: productRes.data?.totalElements });
			setBrands(brandRes.data?.map(el => ({ label: el.name, value: el.id, ...el })) || []);
			setProductType(productTypeRes.data?.map(el => ({ label: el.name, value: el.id, ...el })) || []);
		};
		try {
			init();
		} catch (error) {
			message.error('Có lỗi xảy ra');
		} finally {
			window.setLoading(false);
		}
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(PRODUCT_ENDPOINT, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		// {
		// 	title: 'STT',
		// 	dataIndex: 'index',
		// 	width: 60,
		// 	align: 'center',
		// 	render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		// },
		{
			title: 'Tên Sản phẩm',
			dataIndex: 'name',
			className: 'header-center-align',
			width: 300,
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap', textAlign: 'left' }} type={'link'}
											 onClick={() => gotoDetail(record.id)}>{text}</Button>;
			}
		},
		{
			title: 'Mã sản phẩm',
			dataIndex: 'code',
			align: 'center',
			className: 'header-center-align',
			width: 100,
			render: (text) => <b>{text}</b>
		},
		{
			title: 'Phân loại',
			dataIndex: 'isNormal',
			align: 'center',
			className: 'header-center-align',
			width: 110,
			render: (val) => val ? <Tag style={{ width: '110px' }} color="magenta">Sản phẩm thường</Tag> :
				<Tag style={{ width: '110px' }} color="green">Serial/IMEI</Tag>
		},
		{
			title: 'Tồn kho',
			dataIndex: 'stockQuantity',
			width: 100,
			align: 'center'
		},
		{
			title: 'Ngày khởi tạo',
			dataIndex: 'createdDate',
			width: 170,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Giá nhập',
			dataIndex: 'importPrice',
			align: 'center',
			width: 170,
			render: (text) => (<span>{currencyVND(text)}</span>)
		}
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const goToCreateProduct = () => {
		history.push('/product/create');
	};

	const gotoDetail = (id) => {
		history.push('/product/' + id);
	};

	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};

	const handleDeletes = () => {
		confirm({
			title: `Bạn có chắc chắn muốn xoá ${selectedRow.length} sản phẩm đã chọn không?`,
			content: 'Hành động này không thể hoàn tác.',
			okText: 'Đồng ý',
			cancelText: 'Huỷ bỏ',
			onOk() {
				window.setLoading(true);
				CommonService.post(`${PRODUCT_ENDPOINT}/delete`, selectedRow.map(el => el.id))
					.then(res => {
						if (res.status === 200) {
							message.success(`Xóa thành công ${selectedRow.length} sản phẩm`);
							setSelectedRow([]);
							onSearch(DEFAULT_PAGE);
						}
					}).catch(err => message.error(err))
					.finally(() => window.setLoading(false));
			},
			onCancel() {
				console.log('Đã huỷ');
				// Thực hiện hành động khi huỷ
			},
			okType: 'danger'
		});
	};

	const renderHeader = () => {
		return <div>
			<span>{`Đã chọn ${selectedRow.length} đơn hàng`}</span>
			{selectedRow.length > 0 &&
				<>
					<Button type={'link'} style={{ height: '80%', color: 'red' }} onClick={handleDeletes}>Xóa sản phẩm đã
						chọn</Button>
				</>
			}
		</div>;
	};

	const rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			setSelectedRow(selectedRows);
		}
	};

	return (<Fragment>
			<Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'hidden'}}>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Xuất file')}>Xuất file</span>
						<Divider type="vertical" />
						<Icon type="upload" />
						<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>
					</div>
				</Col>
				<Col>
					<Button type="primary" style={{ width: '150px' }} id={'btn-create-product'} icon="plus"
									onClick={goToCreateProduct}>Thêm sản
						phẩm</Button>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã sản phẩm, tên sản phẩm, IMEI"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'value')}
						onKeyDown={onEnter}
					/>
					<Select
						mode="multiple"
						placeholder="Loại sản phẩm"
						onChange={(value) => handleChange(value, 'productTypeId')}
						style={{ width: '35%' }}
						allowClear
						maxTagCount={1}
						maxTagTextLength={10}
					>
						{productType.map(el => (<Option key={el.id}>{el.name}</Option>))}
					</Select>
					<Select
						mode="multiple"
						placeholder="Nhãn hiệu"
						onChange={(value) => handleChange(value, 'brandId')}
						style={{ width: '30%' }}
						allowClear
						maxTagCount={1}
						maxTagTextLength={10}
					>
						{brands.map(el => (<Option key={el.id}>{el.name}</Option>))}
					</Select>
					<DatePicker.RangePicker
						allowClear
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '600px' }}
						onChange={(value) => {
							const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
									 rowSelection={rowSelection}
									 title={renderHeader}
			/>
		</Fragment>

	);
};
